import script from "./person-card.vue?vue&type=script&setup=true&lang=js"
export * from "./person-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__